/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  Heading,
  Input,
  Text,
  Textarea,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faMapMarkerAlt,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { contactSchema } from "../../schemas/ContactSchema.ts";
import { IContactFormData } from "../../model";

const Contact = () => {
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<IContactFormData>({
    resolver: yupResolver(contactSchema),
  });
  const onSubmit = (data) => {
    console.log(data);
  };
  const { t } = useTranslation();
  return (
    <>
      <Box
        backgroundImage="../assests/AboutPage-Image/breadcrumb-bg.png"
        backgroundRepeat={"no-repeat"}
        backgroundSize="contain"
        backgroundPosition="70%"
        w="100vw"
        h={{ base: "300px", md: "500px", lg: "600px" }}
        pt={{ base: "40px", md: "80px" }}
        position="relative"
      >
        <Text
          position="absolute"
          bottom="22%"
          left={{ base: "12px", md: "80px" }}
          color="white"
          fontSize={{ base: "50px", md: "100px" }}
        >
          <b>{t("Contact")}</b>
        </Text>
      </Box>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box px={"10px"}>
          <Flex
            flexDirection={{ base: "column-reverse", md: "row" }}
            justifyContent="center"
          >
            <Box
              margin={{ base: "0px", md: "100px 0px" }}
              display={"flex"}
              flexDirection={"column"}
              ml={{ base: "80px", md: "0px" }}
            >
              <Box w={{ base: "100%", md: "436px" }} height={"147px"}>
                <Box
                  height={"153px"}
                  display={"flex"}
                  justifyContent={"flex-start"}
                  p={"20px"}
                  gap={"20px"}
                  alignItems={"center"}
                >
                  <FontAwesomeIcon
                    fontSize={"32px"}
                    color="#071450"
                    icon={faMapMarkerAlt}
                  />
                  <Box>
                    <Heading
                      fontSize={"24px"}
                      textTransform={"uppercase"}
                      color={"#071450"}
                    >
                      {t("Location")}
                    </Heading>
                    <Text color={"#071450"} fontWeight={"Bold"}>
                      {t("Baku")}
                    </Text>
                  </Box>
                </Box>
              </Box>
              <Box w={{ base: "100%", md: "436px" }} height={"147px"}>
                <Box
                  height={"147px"}
                  display={"flex"}
                  justifyContent={"flex-start"}
                  p={"20px"}
                  gap={"20px"}
                  alignItems={"center"}
                >
                  <FontAwesomeIcon
                    fontSize={"32px"}
                    color="#071450"
                    icon={faPhone}
                  />
                  <Box>
                    <Heading
                      fontSize={"24px"}
                      textTransform={"uppercase"}
                      color={"#071450"}
                    >
                      {t("Phone")}
                    </Heading>
                    <Text color={"#071450"} fontWeight={"Bold"}>
                      +994 50 215 06 30
                    </Text>
                  </Box>
                </Box>
              </Box>
              <Box w={{ base: "100%", md: "436px" }} height={"147px"}>
                <Box
                  height={"147px"}
                  display={"flex"}
                  justifyContent={"flex-start"}
                  p={"20px"}
                  gap={"20px"}
                  alignItems={"center"}
                >
                  <FontAwesomeIcon
                    fontSize={"32px"}
                    color="#071450"
                    icon={faEnvelope}
                  />
                  <Box>
                    <Heading
                      fontSize={"24px"}
                      textTransform={"uppercase"}
                      color={"#071450"}
                    >
                      {t("Email")}
                    </Heading>
                    <Text color={"#071450"} fontWeight={"Bold"}>
                      info@eventeam.az
                    </Text>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box m={"50px 0px"} w={{ base: "100%", md: "645px" }}>
              <Flex
                direction={"column"}
                w={"70%"}
                mx={"auto"}
                gap={"12px"}
                mt={"20px"}
              >
                <Heading
                  fontSize={{ base: "25px", md: "35px" }}
                  color={"#071450"}
                >
                  {t("Write Message")}
                </Heading>
                <FormControl isInvalid={!!errors.name}>
                  <Controller
                    name="name"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <Input
                        {...field}
                        bg={"#fff"}
                        placeholder={t("Your Name")}
                      />
                    )}
                  />
                  <FormErrorMessage>{errors?.name?.message}</FormErrorMessage>
                </FormControl>
                <FormControl isInvalid={!!errors.name}>
                  <Controller
                    name="email"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <Input
                        {...field}
                        bg={"#fff"}
                        placeholder={t("Your Email")}
                      />
                    )}
                  />
                  <FormErrorMessage>{errors?.email?.message}</FormErrorMessage>
                </FormControl>
                <FormControl isInvalid={!!errors.name}>
                  <Controller
                    name="phone"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <Input {...field} bg={"#fff"} placeholder={t("Phone")} />
                    )}
                  />
                  <FormErrorMessage>{errors?.phone?.message}</FormErrorMessage>
                </FormControl>
                <FormControl isInvalid={!!errors.name}>
                  <Controller
                    name="subject"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <Input
                        {...field}
                        bg={"#fff"}
                        placeholder={t("Subject")}
                      />
                    )}
                  />
                  <FormErrorMessage>{errors.subject?.message}</FormErrorMessage>
                </FormControl>
                <FormControl isInvalid={!!errors.name}>
                  <Controller
                    name="message"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <Textarea
                        {...field}
                        bg={"#fff"}
                        placeholder={t("Write Message")}
                      />
                    )}
                  />
                  <FormErrorMessage>{errors.message?.message}</FormErrorMessage>
                </FormControl>
                <Button type="submit" color="#fff" bg="#66F5FF" mt={4}>
                  {t("Submit")}
                </Button>
              </Flex>
            </Box>
          </Flex>
        </Box>
      </form>
      <Flex width="100%" justifyContent="center">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d194472.76853003312!2d49.69014890705255!3d40.39473700799217!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40307d6bd6211cf9%3A0x343f6b5e7ae56c6b!2sBaku%2C%20Azerbaijan!5e0!3m2!1sen!2sde!4v1729021945256!5m2!1sen!2sde"
          width="100%"
          height="600"
          style={{ border: 0 }}
          loading="lazy"
        ></iframe>
      </Flex>
    </>
  );
};
export default Contact;
